// import { createSlice } from '@reduxjs/toolkit';

// // Helper functions for localStorage persistence
// const loadFiltersFromLocalStorage = () => {
//   try {
//     const savedFilters = localStorage.getItem('filters');
//     const defaultFilters = { price: null, sizes: [] };
//     return savedFilters ? { ...defaultFilters, ...JSON.parse(savedFilters) } : defaultFilters;
//   } catch (err) {
//     console.error("Error loading filters from localStorage:", err);
//     return { price: null, sizes: [] }; // Ensure default structure
//   }
// };


// const saveFiltersToLocalStorage = (filters) => {
//   try {
//     localStorage.setItem('filters', JSON.stringify(filters));
//   } catch (err) {
//     console.error("Error saving filters to localStorage:", err);
//   }
// };

// const initialState = {
//   items: [], // All items
//   filters: loadFiltersFromLocalStorage(), // Load from localStorage
// };

// const itemsSlice = createSlice({
//   name: 'items',
//   initialState,
//   reducers: {
//     setItems: (state, action) => {
//       state.items = action.payload;
//     },
//     applyFilters: (state, action) => {
//       const { price = null, sizes = [] } = action.payload || {};
//       state.filters = { price, sizes };
//       saveFiltersToLocalStorage(state.filters); // Save to localStorage
//     },
    
//     clearFilters: (state) => {
//       state.filters = { price: null, sizes: [] };
//       saveFiltersToLocalStorage(state.filters); // Save cleared filters to localStorage
//     },
//   },
// });

// // Select filtered items based on applied filters
// export const selectFilteredItems = (state) => {
//   const { items, filters } = state.items;

//   return items.filter((item) => {
//     const matchesPrice =
//       !filters.price || (item.price >= filters.price.min && item.price <= filters.price.max);
//     const matchesSize =
//       filters.sizes.length === 0 || filters.sizes.includes(item.size);

//     return matchesPrice && matchesSize;
//   });
// };

// export const { setItems, applyFilters, clearFilters } = itemsSlice.actions;
// export default itemsSlice.reducer;



// import { createSlice } from '@reduxjs/toolkit';

// // Helper functions for localStorage persistence
// const loadFiltersFromLocalStorage = () => {
//   try {
//     const savedFilters = localStorage.getItem('filters');
//     const defaultFilters = { price: null, sizes: [] };
//     return savedFilters ? { ...defaultFilters, ...JSON.parse(savedFilters) } : defaultFilters;
//   } catch (err) {
//     console.error("Error loading filters from localStorage:", err);
//     return { price: null, sizes: [] }; // Ensure default structure
//   }
// };

// const saveFiltersToLocalStorage = (filters) => {
//   try {
//     localStorage.setItem('filters', JSON.stringify(filters));
//   } catch (err) {
//     console.error("Error saving filters to localStorage:", err);
//   }
// };

// const loadClickedItemFromLocalStorage = () => {
//   try {
//     const clickedItem = localStorage.getItem('clickedItem');
//     return clickedItem ? JSON.parse(clickedItem) : null;
//   } catch (err) {
//     console.error("Error loading clicked item from localStorage:", err);
//     return null;
//   }
// };

// const saveClickedItemToLocalStorage = (clickedItem) => {
//   try {
//     localStorage.setItem('clickedItem', JSON.stringify(clickedItem));
//   } catch (err) {
//     console.error("Error saving clicked item to localStorage:", err);
//   }
// };

// // Initial state
// const initialState = {
//   items: [], // All items
//   filters: loadFiltersFromLocalStorage(), // Load filters from localStorage
//   clickedItem: loadClickedItemFromLocalStorage(), // Load clicked item from localStorage
// };

// const itemsSlice = createSlice({
//   name: 'items',
//   initialState,
//   reducers: {
//     setItems: (state, action) => {
//       state.items = action.payload;
//     },
//     applyFilters: (state, action) => {
//       const { price = null, sizes = [] } = action.payload || {};
//       state.filters = { price, sizes };
//       saveFiltersToLocalStorage(state.filters); // Save to localStorage
//     },
//     clearFilters: (state) => {
//       state.filters = { price: null, sizes: [] };
//       saveFiltersToLocalStorage(state.filters); // Save cleared filters to localStorage
//     },
//     setClickedItem: (state, action) => {
//       state.clickedItem = action.payload;
//       saveClickedItemToLocalStorage(action.payload); // Save to localStorage
//     },
//   },
// });

// // Select filtered items based on applied filters
// export const selectFilteredItems = (state) => {
//   const { items, filters } = state.items;

//   return items.filter((item) => {
//     const matchesPrice =
//       !filters.price || (item.price >= filters.price.min && item.price <= filters.price.max);
//     const matchesSize =
//       filters.sizes.length === 0 || filters.sizes.includes(item.size);

//     return matchesPrice && matchesSize;
//   });
// };

// // Selector to get the clicked item
// export const selectClickedItem = (state) => state.items.clickedItem;

// export const { setItems, applyFilters, clearFilters, setClickedItem } = itemsSlice.actions;
// export default itemsSlice.reducer;


import { createSlice } from '@reduxjs/toolkit';

// Helper functions for localStorage persistence
const loadFiltersFromLocalStorage = () => {
  try {
    const savedFilters = localStorage.getItem('filters');
    const defaultFilters = { price: null, sizes: [] };
    return savedFilters ? { ...defaultFilters, ...JSON.parse(savedFilters) } : defaultFilters;
  } catch (err) {
    console.error("Error loading filters from localStorage:", err);
    return { price: null, sizes: [] };
  }
};

const saveFiltersToLocalStorage = (filters) => {
  try {
    localStorage.setItem('filters', JSON.stringify(filters));
  } catch (err) {
    console.error("Error saving filters to localStorage:", err);
  }
};

const loadClickedItemFromLocalStorage = () => {
  try {
    const clickedItem = localStorage.getItem('clickedItem');
    return clickedItem ? JSON.parse(clickedItem) : null;
  } catch (err) {
    console.error("Error loading clicked item from localStorage:", err);
    return null;
  }
};

const saveClickedItemToLocalStorage = (clickedItem) => {
  try {
    localStorage.setItem('clickedItem', JSON.stringify(clickedItem));
  } catch (err) {
    console.error("Error saving clicked item to localStorage:", err);
  }
};

// Initial state
const initialState = {
  items: [], 
  filters: loadFiltersFromLocalStorage(), 
  clickedItem: loadClickedItemFromLocalStorage(), 
};

const itemsSlice = createSlice({
  name: 'items',
  initialState,
  reducers: {
    setItems: (state, action) => {
      state.items = action.payload;
    },
    applyFilters: (state, action) => {
      const { price = null, sizes = [] } = action.payload || {};
      state.filters = { price, sizes };
      saveFiltersToLocalStorage(state.filters);
    },
    clearFilters: (state) => {
      state.filters = { price: null, sizes: [] };
      saveFiltersToLocalStorage(state.filters);
    },
    setClickedItem: (state, action) => {
      const item = action.payload;

      // Ensure default size "M" if no size is provided
      const updatedItem = {
        ...item,
        size: item.size || "M",
      };

      state.clickedItem = updatedItem;
      saveClickedItemToLocalStorage(updatedItem);
    },
  },
});

// Select filtered items based on applied filters
export const selectFilteredItems = (state) => {
  const { items, filters } = state.items;

  return items.filter((item) => {
    const matchesPrice =
      !filters.price || (item.price >= filters.price.min && item.price <= filters.price.max);
    const matchesSize =
      filters.sizes.length === 0 || filters.sizes.includes(item.size);

    return matchesPrice && matchesSize;
  });
};

// Selector to get the clicked item
export const selectClickedItem = (state) => state.items.clickedItem;

export const { setItems, applyFilters, clearFilters, setClickedItem } = itemsSlice.actions;
export default itemsSlice.reducer;
